/**
 * Microcopy de orientação contextual por perfil (pt-BR) para o Hub público da
 * receita. Centralizado para reuso entre /prescricao e /assinatura.
 * Cada texto orienta o perfil que usa aquela ação:
 * - paciente  -> baixar a receita
 * - validador/RH -> validar a assinatura digital
 * - farmácia  -> registrar a dispensação
 */
export const ORIENTACOES_PERFIL = {
  paciente: 'Salve ou imprima sua receita para apresentar na farmácia.',
  validador: 'Confira a validade da assinatura digital no portal oficial do ITI/gov.br.',
  farmacia: 'Farmacêutico: registre a baixa da dispensação deste documento.',
} as const

export const URL_VALIDAR_ICP = 'https://validar.iti.gov.br'
